import { get, post, put, postForm } from 'utils/methods';

export function getTranslationsApi(params) {
    return get(`${process.env.REACT_APP_REST}product-translates`, params);
}

export function editTranslationsApi(data, product) {
    return post(`${process.env.REACT_APP_REST}commands/${product}/translate`, data);
}

export function addTranstaltionTagApi(params) {
    return post(`${process.env.REACT_APP_REST}commands/translation`, params);
}

export function editTranstaltionTagApi(params) {
    return put(`${process.env.REACT_APP_REST}commands/translation`, params);
}

export function rebuildApi(params) {
    return get(`${process.env.REACT_APP_HOST}rebuild`, params);
}

export function uploadFileApi(params) {
    return postForm(`${process.env.REACT_APP_REST}file/upload`, params);
}
